export const messageLoaders: Record<string, () => Promise<any>> = {
  fr: () => import('../../lang/compiled/fr.intl.output.json'),
  es: () => import('../../lang/compiled/es.intl.output.json'),
  pt: () => import('../../lang/compiled/pt.intl.output.json'),
  de: () => import('../../lang/compiled/de.intl.output.json'),
  nl: () => import('../../lang/compiled/nl.intl.output.json')
};
